import axios from '@/common/lib/axios';
import { AxiosRequestConfig } from 'axios';
import { Business_URL, Campaign_URL, User_URL } from '@/common/lib/url';

export const NO_AVATAR_URL = '/assets/img/no-user-avatar.png';

export async function handleImageUpload(
  type: 'user' | 'campaign' | 'business',
  fileInput: HTMLInputElement | null,
  campaignId?: string
): Promise<string> {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
    throw new Error('No file selected');
  }

  const data = new FormData();
  data.append('avatar', fileInput.files[0]);

  let url;
  const config: AxiosRequestConfig = {};
  switch (type) {
    case 'user':
      url = User_URL + 'avatar';
      break;
    case 'campaign':
      url = Campaign_URL + 'avatar';
      if (campaignId) {
        config.params = { campaignId };
      }
      break;
    case 'business':
      url = Business_URL + 'avatar';
      break;
    default:
      throw new Error('Invalid types');
  }

  const response = await axios.post(url, data, config);
  if (response.data.success) {
    return response.data.image;
  } else {
    throw new Error('Error updating avatar');
  }
}

export function updateBackgroundImages(className: string): void {
  const elements = document.querySelectorAll(`.${className}`);
  elements.forEach(element => {
    const imgSrc = element.getAttribute('data-img');
    if (imgSrc) {
      const img = new Image();
      img.onload = () => {
        (element as HTMLElement).style.backgroundImage = `url('${imgSrc}')`;
        (element as HTMLElement).style.backgroundPosition = 'center';
        (element as HTMLElement).style.backgroundSize = 'cover';
      };
      img.onerror = () => {
        // Set fallback avatar if image fails to load
        (element as HTMLElement).style.backgroundImage = `url('${NO_AVATAR_URL}')`;
      };
      img.src = imgSrc;
    } else {
      // Set fallback avatar if no src is provided
      (element as HTMLElement).style.backgroundImage = `url('${NO_AVATAR_URL}')`;
    }
  });
}
